import * as React from "react"
import { FramerEventSession } from "../FramerEventSession"
import { FramerEvent } from "../"
import { safeWindow } from "../../utils/safeWindow"

export interface Props {
    session: FramerEventSession
}

/**
 * @internal
 */
export class TouchEventListener extends React.Component<Props> {
    /**
     * @internal
     */
    render() {
        return this.props.children
    }

    /**
     * @internal
     */
    componentDidMount() {
        safeWindow.addEventListener("touchstart", this.domTouchStart)
    }

    /**
     * @internal
     */
    componentWillUnmount() {
        safeWindow.removeEventListener("touchstart", this.domTouchStart)
        safeWindow.removeEventListener("touchmove", this.domTouchMove)
        safeWindow.removeEventListener("touchend", this.domTouchEnd)
    }

    /**
     * @internal
     */
    domTouchStart = (originalEvent: TouchEvent) => {
        safeWindow.addEventListener("touchmove", this.domTouchMove)
        safeWindow.addEventListener("touchend", this.domTouchEnd)
        const event = new FramerEvent(originalEvent, this.props.session)
        this.props.session.pointerDown(event)
    }

    /**
     * @internal
     */
    domTouchMove = (originalEvent: TouchEvent) => {
        const event = new FramerEvent(originalEvent, this.props.session)
        this.props.session.pointerMove(event)
    }

    /**
     * @internal
     */
    domTouchEnd = (originalEvent: TouchEvent) => {
        safeWindow.removeEventListener("touchmove", this.domTouchMove)
        safeWindow.removeEventListener("touchend", this.domTouchEnd)
        const event = new FramerEvent(originalEvent, this.props.session)
        this.props.session.pointerUp(event)
    }
}
